import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import styled from 'styled-components';
import HeaderContainer from '../../components/sdk-page/header';
import { FeatureList, FeaturesRow, Feature } from '../../components/sdk-page/features';
import ContextLink from '../../components/context-link';
import customizeIcon from '../../images/icons/Customize@2x.png';
import analyticsIcon from '../../images/icons/Analytics@2x.png';
import contentIcon from '../../images/icons/Content@2x.png';
import featuresIcon from '../../images/icons/Features@2x.png';
import loadingIcon from '../../images/icons/Loading@2x.png';
import safeContentIcon from '../../images/icons/SafeContent@2x.png';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <HeaderContainer mdxType="HeaderContainer">
      <h2>{`GIPHY SDK`}</h2>
      <p>{`By integrating with GIPHY, the first and largest GIF search engine, you gain free access to our ever-growing content library of GIFs and Stickers, plus brand new features like animated Emoji and Text — featuring the latest in entertainment, sports, and breaking news from GIPHY's official content partners.`}</p>
      <p>{`The fastest and easiest way to bring the full GIPHY experience directly to your app is with GIPHY SDK. Built with developers and product designers in mind, GIPHY SDK is a top-to-bottom solution for all things GIF in your app. This includes interfacing with GIPHY API, fetching and caching assets, and displaying GIFs and Stickers on screen in customizable UI templates.`}</p>
      <p>{`With billions of requests a day, it’s safe to say GIPHY knows GIFs. We're excited to share our best-in-class tools with you so your users can have the best GIF experience possible, with all the same features they're already enjoying on Facebook, Slack, Instagram, and more – with just a few lines of code.`}</p>
      <p>{`Here’s what GIPHY SDK offers:`}</p>
    </HeaderContainer>
    <FeatureList mdxType="FeatureList">
    <FeaturesRow mdxType="FeaturesRow">
        <Feature icon={customizeIcon} title="Customizable UI Templates" mdxType="Feature">
            <p>
                Our team in NYC designed flexible UI kits for our SDK users, so you can customize your GIPHY integration
                without any of the hard work. Check them out{' '}
                <ContextLink to="/docs/sdk#design-guidelines" mdxType="ContextLink">here</ContextLink>!
            </p>
        </Feature>
        <Feature icon={contentIcon} title="Best-in-Class Content" mdxType="Feature">
            <p>
                World class movie studios, TV networks, sports leagues, brands, influencers and artists use GIPHY every
                day to share an enormous library of high quality content with our network.
            </p>
        </Feature>
    </FeaturesRow>
    <FeaturesRow mdxType="FeaturesRow">
        <Feature icon={loadingIcon} title="Optimized Loading & Renditions" mdxType="Feature">
            <p>
                We offer extensive <a href="/docs/optional-settings#rendition-guide">rendition options</a> for different
                platforms and devices to ensure loading GIPHY content doesn’t get in the way of your app’s speed.
            </p>
        </Feature>
        <Feature icon={analyticsIcon} title="Analytics" mdxType="Feature">
            <p>
                <a href="/docs/api/endpoint#action-register">GIPHY Analytics</a> helps improve your users’ search
                results and keeps them coming back for more.
            </p>
        </Feature>
    </FeaturesRow>
    <FeaturesRow mdxType="FeaturesRow">
        <Feature icon={featuresIcon} title="Exclusive Access" mdxType="Feature">
            <p>
                GIPHY’s newest content and features, like animated text and emoji, will be available exclusively on the
                GIPHY SDK, along with all future releases.
            </p>
        </Feature>
        <Feature icon={safeContentIcon} title="Safe Content" mdxType="Feature">
            <p>
                Our content is moderated so you can feel secure knowing content served through GIPHY is{' '}
                <a href="https://support.giphy.com/hc/en-us/sections/360003012792-Privacy-and-Safety" target="_blank">
                    safe for distribution
                </a>
                .
            </p>
        </Feature>
    </FeaturesRow>
    </FeatureList>
    <p>{`If you're already familiar with our API, you'll be glad to know GIPHY SDK includes all of its best features, but takes a fraction of the time to implement.`}</p>
    <p>{`Before you get started, head over to our sample app repository for `}<a href="https://github.com/Giphy/giphy-ios-sdk-ui-example">{`iOS`}</a>{` or `}<a href="https://github.com/Giphy/giphy-android-sdk-ui-example">{`Android`}</a>{` to check out GIPHY SDK in action, along with example code.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      